export const Input = ({
  lang = "en",
  type,
  name,
  value,
  onChange,
  placeholder,
  required,
  min,
  maxLength,
  rows,
  inValid,
}) => (
  <input
    type={type}
    name={name}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    required={required}
    min={min}
    maxLength={maxLength}
    // language attribute to support RTL languages
      onInvalid={(e) => {
    e.target.setCustomValidity(
      lang === 'ar'
        ? 'يرجى ملء هذا الحقل'
        : 'Please fill out this field.'
    );
  }}
    onInput={(e) => e.target.setCustomValidity('')}
   
    rows={rows}
    className={`w-full h-12 px-3 py-2 text-lg text-gray-700 border border-gray-200 rounded-lg focus:outline-none placeholder-gray-400 font-normal ${
      inValid && "border-red-500"
    }`}
  />
);

export const InputLabel = ({ children }) => (
  <label className="block text-text-medium text-[16px] font-[600] mb-2">
    {children} <span className="text-red-500">*</span>
  </label>
);
